export default {
  maxWidth: "1200px",
  borderRadius: "6px",
  elevationInner: `inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)`,
  elevation1: `0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)`,
  elevation2: `0 3px 6px rgba(0,0,0,.15), 0 2px 4px rgba(0,0,0,.12)`,
  elevation3: `0 10px 20px rgba(0,0,0,.15), 0 3px 6px rgba(0,0,0,.1)`,
  elevation4: `0 15px 25px rgba(0,0,0,.15), 0 5px 10px rgba(0,0,0,.05)`,
  elevation5: `0 20px 40px rgba(0,0,0,.2)`,
  primary: {
    "100": "#EBF4FF",
    "200": "#C3DAFE",
    "300": "#A3BFFA",
    "400": "#7F9CF5",
    "500": "#506CE7",
    "600": "#5A67D8",
    "700": "#4C51BF",
    "800": "#434190",
    "900": "#3C366B",
  },
  grey: {
    "0": "#FFFFFF",
    "50": "hsl(204, 30%, 98%)",
    "100": "#F7FAFC",
    "200": "#EDF2F7",
    "300": "#E2E8F0",
    "400": "#CBD5E0",
    "500": "#A0AEC0",
    "600": "#718096",
    "700": "#4A5568",
    "800": "#2D3748",
    "900": "#1A202C",
  },
}
